class LollipopPetal {
  constructor() {
    this.index = 0;
    this.detail = null;
    this.lollipop = null;
  }

  addVariant(detail) {
    this.detail = detail;
  }

  getVariantId() {
    return this.detail?.variant?.id;
  }

  containedInAny(filters) {
    return filters.find((x) => this.detail.variant.inSamples.has(x));
  }

  overlapWithCNVSamples(samples) {
    return samples.find((x) => this.detail.cnvOverlapSampleSet.has(x));
  }

  containedInAll(filters) {
    return filters.reduce(
      (a, i) => a && this.detail.variant.inSamples.has(i),
      true
    );
  }

  addToLollipop(lollipop) {
    if (this.lollipop) return;
    this.index = lollipop.petalSize || 0;
    this.lollipop = lollipop;
    lollipop.addPetal();
  }

  get pathoIndex() {
    return this.detail?.pathoIndex;
  }

  get phasing() {
    return this.detail?.phasingGroup;
  }

  get region() {
    return this.detail?.variant?.region;
  }

  get variant() {
    return this.detail?.variant;
  }
}

export default LollipopPetal;
